import React, { useState } from 'react';
import './header.css';

export function Header({isMobile}) {
  const [menuOpen0, setMenuOpen0] = useState(false);
  const [menuOpen1, setMenuOpen1] = useState(false);
  const [menuOpen2, setMenuOpen2] = useState(false);
  const [menuOpen3, setMenuOpen3] = useState(false);
  const [menuOpen4, setMenuOpen4] = useState(false);

  const toggleMenu0 = () => setMenuOpen0(!menuOpen0);
  const toggleMenu1 = () => setMenuOpen1(!menuOpen1);
  const toggleMenu2 = () => setMenuOpen2(!menuOpen2);
  const toggleMenu3 = () => setMenuOpen3(!menuOpen3);
  const toggleMenu4 = () => setMenuOpen4(!menuOpen4);

  if (isMobile) {
      return (
    <header className="header">
      {/* Logo quadrado */}
      <div className="logo-container">
        <a href="/" title="Domínio Elétrico" className="logo-link">
                <img
                src="/dominio_eletrico_logo_2023_square_fundo_transparente.png"
                alt="Logo do Domínio Elétrico"
                className="logo"
                />
        </a>
      </div>

        <nav className="nav">
        <button onClick={toggleMenu0} className="menu-button">
        Menu ▼
        </button>
        {menuOpen0 && (
        <ul className="dropdown">
            <li className="menu-title"><b>Playlists gratuitas</b></li>
            <li><a href="/coursepage/course-56b761" className="link">Vídeos de Experimentos</a></li>
            <li><a href="/coursepage/course-fcb449" className="link">Aulas Longas de Circuitos Elétricos</a></li>
            <li><a href="/coursepage/course-ab9f17" className="link">Multivibrador Astável</a></li>
            <li><a href="/coursepage/course-95f159" className="link">Erros Elétricos</a></li>
            <li><a href="/coursepage/course-cf3471" className="link">Exercícios Resolvidos 2020</a></li>
            <li><a href="/coursepage/course-0dcebf" className="link">Exercícios Resolvidos 2022</a></li>
            <li><a href="/coursepage/course-5c5292" className="link">Exercícios Resolvidos 2023</a></li>
            <li className="menu-title"><b>Cursos premium</b></li>
            <li><a href="/coursepage/course-a75cc2" className="link">Domínio Elétrico</a></li>
            <li><a href="/coursepage/course-186d6b" className="link">Lives Canal do Elétron</a></li>
            <li><a href="/coursepage/course-ce8071" className="link">Domínio Elétrico Labs</a></li>
            <li><a href="/coursepage/course-19fb51" className="link">Matemática do Elétron</a></li>
            <li><a href="/coursepage/course-f96078" className="link">Como estudar melhor na engenharia</a></li>
            <li className="menu-title"><b>Sobre</b></li>
            <li><a href="/espera-dominio-eletrico" className="link">Sobre o curso principal</a></li>
            <li><a href="/anslist" className="link">Perguntas & Respostas</a></li>
            <li><a href="/allcourses" className="link">Todos os cursos</a></li>
        </ul>
        )}
        </nav>

        <div className="login-icon-container">
          <a href="/logon" title="Fazer login" className="login-link">
            🔐 Login
          </a>
        </div>

    </header>
  );
  }
  else {
      return (
    <header className="header">
      {/* Logo quadrado */}
      <div className="logo-container">
        <a href="/" title="Domínio Elétrico" className="logo-link">
                <img
                src="/dominio_eletrico_logo_2023_square_fundo_transparente.png"
                alt="Logo do Domínio Elétrico"
                className="logo"
                />
        </a>
      </div>

        <nav className="nav">
            <button onClick={toggleMenu1} className="menu-button">
            Textos ▼
            </button>
            {menuOpen1 && (
            <ul className="dropdown">
                <li><a href="/anslist" className="link">Perguntas & Respostas</a></li>
            </ul>
            )}
        </nav>

        {/* Menu drop-down */}
        <nav className="nav">
            <button onClick={toggleMenu2} className="menu-button">
            Playlists gratuitas ▼
            </button>
            {menuOpen2 && (
            <ul className="dropdown">
                <li><a href="/coursepage/course-56b761" className="link">Vídeos de Experimentos</a></li>
                <li><a href="/coursepage/course-fcb449" className="link">Aulas Longas de Circuitos Elétricos</a></li>
                <li><a href="/coursepage/course-ab9f17" className="link">Multivibrador Astável</a></li>
                <li><a href="/coursepage/course-95f159" className="link">Erros Elétricos</a></li>
                <li><a href="/coursepage/course-cf3471" className="link">Exercícios Resolvidos 2020</a></li>
                <li><a href="/coursepage/course-0dcebf" className="link">Exercícios Resolvidos 2022</a></li>
                <li><a href="/coursepage/course-5c5292" className="link">Exercícios Resolvidos 2023</a></li>
            </ul>
            )}
        </nav>

            {/* Menu drop-down */}
        <nav className="nav">
            <button onClick={toggleMenu3} className="menu-button">
            Cursos premium ▼
            </button>
            {menuOpen3 && (
            <ul className="dropdown">
                <li><a href="/coursepage/course-a75cc2" className="link">Domínio Elétrico</a></li>
                <li><a href="/coursepage/course-186d6b" className="link">Lives Canal do Elétron</a></li>
                <li><a href="/coursepage/course-ce8071" className="link">Domínio Elétrico Labs</a></li>
                <li><a href="/coursepage/course-19fb51" className="link">Matemática do Elétron</a></li>
                <li><a href="/coursepage/course-f96078" className="link">Como estudar melhor na engenharia</a></li>
            </ul>
            )}
        </nav>

            {/* Menu drop-down */}
        <nav className="nav">
            <button onClick={toggleMenu4} className="menu-button">
            Sobre ▼
            </button>
            {menuOpen4 && (
            <ul className="dropdown">
                <li><a href="/espera-dominio-eletrico" className="link">Sobre o curso principal</a></li>
                <li><a href="/anslist" className="link">Perguntas & Respostas</a></li>
                <li><a href="/allcourses" className="link">Todos os cursos</a></li>
            </ul>
            )}
        </nav>
            

      {/* Ícone de login para desktop */}
        <div className="login-icon-container">
          <a href="/logon" title="Fazer login" className="login-link">
            🔐 Fazer login
          </a>
        </div>
    </header>
  );
  }
}
